import { render } from "./Breadcrumbs.vue?vue&type=template&id=51cba4df"
const script = {}

import "./Breadcrumbs.vue?vue&type=style&index=0&id=51cba4df&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__